"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryPublicFloodZone = void 0;
const index_1 = require("../index");
const queryPublicFloodZone = async (request, url) => {
    return (0, index_1.queryPublicArcGIS)(url, request, "FLD_ZONE", false).then((response) => {
        var _a, _b;
        const responseArray = (_b = (_a = response === null || response === void 0 ? void 0 : response.features) === null || _a === void 0 ? void 0 : _a.map((feature) => feature === null || feature === void 0 ? void 0 : feature.properties)) !== null && _b !== void 0 ? _b : null;
        let responseToReturn = null;
        if (responseArray &&
            responseArray.length > 0 &&
            responseArray[0]["FLD_ZONE"]) {
            responseToReturn = responseArray[0]["FLD_ZONE"];
        }
        return responseToReturn;
    });
};
exports.queryPublicFloodZone = queryPublicFloodZone;
//# sourceMappingURL=floodZones.js.map